function _parseCookies() {
  let cookies = {};

  document.cookie.split(';').forEach((cookie) => {
    let [name, value] = cookie.split('=');
    cookies[name.trim()] = decodeURIComponent(value);
  });

  return cookies;
}

export default function getSessionId() {
  return _parseCookies()['pn-subscribe'];
}
